export const millisecondsToTime: (milliseconds: number, excludeHours?: boolean) => string = (
	milliseconds,
	excludeHours,
) => {
	// Pad to 2 or 3 digits, default is 2
	const pad = (n: number, length?: number) => {
		return ("00" + n).slice(-(length || 2));
	};

	const ms = milliseconds % 1000;
	let s = (milliseconds - ms) / 1000;
	const secs = s % 60;
	s = (s - secs) / 60;
	const mins = s % 60;
	const hrs = (s - mins) / 60;

	return `${!excludeHours ? `${pad(hrs, 2)}:` : ""}${pad(mins, excludeHours ? 1 : 2)}:${pad(secs, 2)}`;
};
